import { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';

import { BrowserRouter, Route, Routes, Link } from "react-router-dom"
import { useLocation } from 'react-router'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Container } from '@mui/material';

import Header from "./Header";

import Part1 from './Part1';
import Part2 from './Part2';
import Part3 from './Part3';
import Part4 from './Part4';

import Article from './Section4/Article'


function Layout() {


  return (

    <>

      <Box className="main fullheight">

        <Grid id="main" container flexDirection="column" flexWrap={"nowrap"} className="fullheight">

          <Grid>
            <Header />
          </Grid>

          <Grid flexGrow={10}>
              <Routes>
                {/* Your app content */}
                <Route path="/" element={<Part1 />} />
                <Route path="/phyto" element={<Part2 />} />
                <Route path="/report" element={<Part3 />} />
                <Route path="/news" element={<Part4 />} />
                <Route path="/essay" element={<Article />} />
              </Routes>
          </Grid>

        </Grid>
      </Box>

    </>

  );
}

export default Layout;
